const toPositiveId = (value) => {
  const number = Number(value);
  return Number.isInteger(number) && number > 0 ? String(number) : "";
};

const userIdCandidates = (user) => [
  user?.emp_id,
  user?.empId,
  user?.worker_id,
  user?.workerId,
  user?.employee_id,
  user?.employeeId,
];

const userNameCandidates = (user) =>
  [
    user?.emp_name,
    user?.employee_name,
    user?.employeeName,
    user?.worker_name,
    user?.workerName,
    user?.user_name,
    user?.name,
  ]
    .map((value) => String(value || "").trim())
    .filter(Boolean);

export const resolveEmployeeId = ({ user, queryEmpId, employees = [] }) => {
  const directId = [queryEmpId, ...userIdCandidates(user)]
    .map(toPositiveId)
    .find(Boolean);

  if (directId) return directId;

  const names = userNameCandidates(user);
  if (!names.length || !employees.length) return "";

  const matches = employees.filter((employee) =>
    names.includes(String(employee.emp_name || "").trim())
  );

  return matches.length === 1 ? toPositiveId(matches[0].emp_id) : "";
};

export const getEmployeeName = ({ empId, employees = [], fallback = "" }) => {
  const id = toPositiveId(empId);
  const employee = employees.find((item) => String(item.emp_id) === id);
  return employee?.emp_name || fallback;
};
